import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from 'tss-react/mui';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { units } from '../theme/units';
const useStyles = makeStyles()((theme, _params, classes) => ({
    root: {
        zIndex: 1,
        [`&.${classes.expanded}`]: {
            zIndex: 1,
            marginTop: 0,
            backgroundColor: theme.palette.grey[50],
        },
    },
    expanded: {},
    content: {
        zIndex: 1,
    },
    withMargin: {
        margin: units.trbl(1.25, 0, 1.25, 0),
    },
}));
const Expandable = ({ summary, details, expanded, elevation, square, onChange, panelStyle, detailsClassname, variant = 'default', ...rest }) => {
    const { classes, cx } = useStyles();
    const handleChange = onChange
        ? // eslint-disable-next-line @typescript-eslint/ban-types
            (_, isExpanded) => onChange(isExpanded)
        : undefined;
    const contentClass = cx(classes.content, {
        [classes.withMargin]: variant !== 'narrow',
    });
    return (_jsxs(Accordion, { style: panelStyle, classes: {
            expanded: classes.expanded,
            root: classes.root,
        }, expanded: expanded, elevation: elevation, square: square, onChange: handleChange, ...rest, children: [_jsx(AccordionSummary, { classes: {
                    root: classes.root,
                    expanded: classes.expanded,
                    content: contentClass,
                }, expandIcon: _jsx(ExpandMoreIcon, { "data-test-locator": "Icon - ExpandMore" }), children: summary }), _jsx(AccordionDetails, { className: detailsClassname, children: details })] }));
};
export { Expandable };
